import React from 'react';

import { 
  Grid,
  Typography,
}                  from '@material-ui/core';

export default function ExecutionOverrides(props) {
  const { execution } = props;
  
  if(!execution || !execution.Overrides) {
    return(null);
  }
  
  const overrides=Object.entries(execution.Overrides).sort((a, b) => b[0].localeCompare(a[0]));
  return (
    <Grid container spacing={1}>
      {overrides.map( ([k,v]) =>
        <React.Fragment key={k}>
          <Grid item>
            <Typography variant='caption'>{k}</Typography>
          </Grid>
          <Grid item>
            <Typography variant='body2'>{String(v)==='true'?"":String(v)}</Typography>
          </Grid>
        </React.Fragment>
      )}
    </Grid>
  );
}
